import React, {useState} from 'react';
import {Paciente} from './Paciente';
import {Usuario} from '../Usuarios/Usuario';
import {FormularioUsuarios} from '../Usuarios/FormularioUsuarios';

export const FormularioPacientes = ({idUsuario, setPantallaPerfil}) => {
	/* Creating a state variable called Usuario and setting it to an object with the following
    properties:
    nombre, apellidos, fechaInicioServicio, notas, numeroExpediente, fechaNacimiento, numeroSS, dni,
    direccion, telefono1, telefono2, tipoUsuario, trabajadorSocial, tipologia, estadoCivil,
    entidades, otros. */
	const [UsuarioA, setUsuario] = useState({
		nombre: 'UsuarioPrueba',
		apellidos: 'Apellidos',
		fechaInicioServicio: '03/05/2022',
		notas: 'Notas Varias',
		numeroExpediente: '23452435',
		fechaNacimiento: '01/01/1989',
		numeroSS: '24523452435',
		dni: '123457A',
		direccion: 'C/ Jose antonio tomimas 23',
		telefono1: '123456789',
		telefono2: '666666666',
		tipoUsuario: 'Privado',
		/** provado o contrarestado */
		trabajadorSocial: 'Juan Antonio Perez',
		tipologia: '?',
		estadoCivil: 'Soltero',
		entidades: 'Mafre',
		otros: 'Es una persona',
	});

	const [UsuarioB, setUsuarioB] = useState({
		fotoUsuario: '',
		nombreUsuario: 'Juan',
		idUsuario: '74320985',
		telefonoUsuario: '633333333',
		correoUsuario: 'usuario123@correro.com',
		telefonoUsuario2: '600300300',
		nombreUsu: 'Juanito',
	});

	const [viewUsuario, setViewUsuario] = useState(false);

	/**
	 * A function that handles the change of the input.
	 */
	const handleInpuntChange = (event) => {
		setUsuario({
			...UsuarioA,
			[event.target.name]: event.target.value,
		});
	};

	/* Creating a state variable called SelectOption1 and setting it to the value "Soltero" */
	const [SelectOption1, setSelectOption1] = useState('Soltero');

	/**
	 * A function that handles the change of the radio button.
	 */
	const handleOptionChangeRadio1 = (event) => {
		setSelectOption1(event.target.value);
		handleInpuntChange(event);
	};

	/* Creating a state variable called SelectOption2 and setting it to the value of "Privado" */
	const [SelectOption2, setSelectOption2] = useState('Privado');

	/**
	 * A function that handles the change of the radio button.
	 */
	const handleOptionChangeRadio2 = (event) => {
		setSelectOption2(event.target.value);
		handleInpuntChange(event);
	};

	/**
	 * A function that is called when the user clicks on the "Guardar Cambios" button.
	 */
	const guardarCambios = () => {
		console.log('Guradar datos paciente');
		setPantallaPerfil(false);
	};

	return (
		<>
			{!viewUsuario ? (
				<div className='centrador'>
					<div className='formularioUsuario'>
						<div
							className='buttonAtrasFormularioUsuario'
							onClick={() => setPantallaPerfil(false)}
						>
							Atrás
						</div>
						<div className='contentFormularioUsuario'>
							<div className='fotoUser'>
								<div className='centrador'>
									<img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images' />
								</div>
								<div className='centrador nombreID'>
									<div className='centrador nombreUsuarioForm'>
										{'Paciente de prueba'}
									</div>
									<div className='IDUsuario'>
										<b>ID : </b>
										{idUsuario}
									</div>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Nombre</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.nombre}
										name={'nombre'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Apellidos</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.apellidos}
										name={'apellidos'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Numero de expediente</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.numeroExpediente}
										name={'numeroExpediente'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>DNI</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.dni}
										name={'dni'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Dirección</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.direccion}
										name={'direccion'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Teléfono 1</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.telefono1}
										name={'telefono1'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Teléfono 2 (opcional)</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.telefono2}
										name={'telefono2'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Número Seguridad Social</div>
								<div>
									<input
										type='text'
										className='inputTextUsuario'
										value={UsuarioA.numeroSS}
										name={'numeroSS'}
										onChange={handleInpuntChange}
										placeholder={''}
									/>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Estado civil (opcinal)</div>
								<div className='buttonRadioFormUsu'>
									<div className='contentButtonRadioFormUsu'>
										<div>Soltero</div>
										<input
											type='radio'
											value={'Soltero'}
											name={'estadoCivil'}
											checked={SelectOption1 === 'Soltero'}
											onChange={handleOptionChangeRadio1}
										/>
									</div>
									<div className='contentButtonRadioFormUsu'>
										<div>Casado</div>
										<input
											type='radio'
											value={'Casado'}
											name={'estadoCivil'}
											checked={SelectOption1 === 'Casado'}
											onChange={handleOptionChangeRadio1}
										/>
									</div>
								</div>
							</div>
							<div className='datoFormularioUsuario'>
								<div className='labelDatoFormUsu'>Fecha de nacimiento</div>
								<div>
									<input type='date' />
								</div>
							</div>
							<div className='datoFormularioUsuarioNotas'>
								<div className='labelDatoFormUsuNotas'>Notas (opcinal)</div>
								<div className='inputNotas'>
									<input
										className='inputTextUsuario'
										type='text'
										value={UsuarioA.notas}
										name={'notas'}
										onChange={handleInpuntChange}
									/>
								</div>
							</div>
						</div>
						<div className='buttonGuardar'>
							<div
								className='button'
								onClick={guardarCambios}
							>
								<b>Guardar cambios</b>
							</div>
						</div>
					</div>
					<div className='usuarioAsociado'>
						<div className='listaUsurios'>
							<div className='centradorLeft titleHeadHistorialFacturas titleEnPacientes'>
								Usuario asociado{' '}
							</div>
							<Usuario
								fotPantallaPerileccionUsuario={''}
								nombreUsuario={UsuarioB.nombreUsuario}
								idUsuario={UsuarioB.idUsuario}
								nombreUsu={UsuarioB.nombreUsu}
								telefonoUsuario={UsuarioB.telefonoUsuario}
								telefonoUsuario2={UsuarioB.telefonoUsuario2}
								correoUsuario={UsuarioB.correoUsuario}
								abrirPerfil={() => {
									setViewUsuario(true);
								}}
							/>
						</div>
					</div>
				</div>
			) : (
				<FormularioUsuarios
					idUsuario={UsuarioB.idUsuario}
					setPantallaPerfil={() => {
						setViewUsuario(false);
					}}
				/>
			)}
		</>
	);
};
